module.exports = __webpack_public_path__ + "img/consejo.29fbcd71.png";